(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/wager-payment-flow/selfservice-flow/assets/javascripts/selfservice-flow.js') >= 0) return;  svs.modules.push('/components/wager-payment-flow/selfservice-flow/assets/javascripts/selfservice-flow.js');
"use strict";

const {
  selfserviceCart
} = svs.components;
const {
  getLogger
} = svs.core.log;
const {
  formatDate
} = svs.components.lbUtils.helpers.formatDate;
const placeSelfServiceBet = wagerWrapper => new Promise((resolve, reject) => {
  selfserviceCart.getCartInstance().actions.addItem(wagerWrapper, err => {
    if (err) {
      reject(err);
    } else {
      resolve();
    }
  });
});

const createSelfServicePaymentFlow = async _ref => {
  let {
    wagers,
    regCloseTimes,
    brandLogos
  } = _ref;
  let wagerCount = 0;
  const logger = getLogger('wager-flow:selfservice-cart');
  for (const wager of wagers) {
    try {
      var _brandLogos$wagers$in;
      const cost = wager.bets.reduce((sum, bet) => bet.price + sum, 0); 
      const productNames = wager.getProductsInBet();
      const productName = productNames[0];
      const itsWager = wager.compose();
      let regCloseTime;
      if (!isNaN(Date.parse(regCloseTimes[wagers.indexOf(wager)]))) {
        regCloseTime = "".concat(formatDate(new Date(regCloseTimes[wagers.indexOf(wager)]), true, true));
      } else {
        regCloseTime = regCloseTimes[wagers.indexOf(wager)];
      }
      const productItemInfo = {
        wagers: itsWager,
        isLive: false,
        headers: {
          source: 'SvS:LB:ITS'
        },
        productFlag: productName,
        productTitle: productName,
        productBrand: (_brandLogos$wagers$in = brandLogos === null || brandLogos === void 0 ? void 0 : brandLogos[wagers.indexOf(wager)]) !== null && _brandLogos$wagers$in !== void 0 ? _brandLogos$wagers$in : productName.toLowerCase(),
        cost,
        description: "Spelstopp: ".concat(regCloseTime),
        addonProductName: undefined
      };
      const wagerWrapper = selfserviceCart.generateProductItem(productItemInfo);
      await placeSelfServiceBet(wagerWrapper);
      wagerCount = wagerCount + 1;
    } catch (err) {
      logger.info("Failed adding wager to selfservice-cart, error: ".concat(err));
    }
  }
  return wagerCount;
};
setGlobal('svs.components.wagerPaymentFlow.selfServiceFlow.createSelfServicePaymentFlow', createSelfServicePaymentFlow);

 })(window);